import * as fromDatatype from '../datatype-library/index';

export interface bl_mlm_lineage_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    level: fromDatatype.IntegerDatatypeInterface;
    lineage_type: fromDatatype.VarcharDatatypeInterface;
    parent_participant_guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    child_participant_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_guid: fromDatatype.GuidDataFieldInterface;
    parent_member_guid: fromDatatype.GuidDataFieldInterface;
    child_member_guid: fromDatatype.GuidDataFieldInterface;
    referral_source: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_mlm_lineage_hdr_RowClass implements bl_mlm_lineage_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    program_guid: fromDatatype.GuidDataFieldInterface;
    level: fromDatatype.IntegerDatatypeInterface;
    lineage_type: fromDatatype.VarcharDatatypeInterface;
    parent_participant_guid: fromDatatype.GuidDataFieldInterface;
    parent_entity_guid: fromDatatype.GuidDataFieldInterface;
    child_participant_guid: fromDatatype.GuidDataFieldInterface;
    child_entity_guid: fromDatatype.GuidDataFieldInterface;
    parent_member_guid: fromDatatype.GuidDataFieldInterface;
    child_member_guid: fromDatatype.GuidDataFieldInterface;
    referral_source: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
}